/*
 * APP ENTRY POINT
 *
 * RENDERS THE APPLICATION’S ROOT CONTAINER AND MOUNTS THE ChatLauncher,
 * WHICH HANDLES THE INITIAL SUGGESTION BUBBLES, ORANGE CHAT BUTTON,
 * AND FULL ChatWindow LIFECYCLE (OPEN/CLOSE, PERSISTENCE, MESSAGING, SLIDE-IN).
 *
 *
 * VIEWPORT + HOST DETECTION STRATEGY:
 * -----------------------------------
 * > Supports two methods of configuration:
 *    1. postMessage from parent iframe container (preferred, dynamic).
 *    2. URL query parameters ?host=...&vw=... (fallback, static).
 *
 * > The 'viewport' is classified into one of:
 *    - 'desktop'  : width >= 1000
 *    - 'tablet'   : width >= 680
 *    - 'mobile'   : width < 680
 *
 * > The 'host' is expected to be a valid full URL or a bare hostname (auto-prefixed with https://).
 *
 * > These values are passed down into ChatLauncher, which controls responsive behavior,
 *   environment-specific logic, and network-related decisions.
 */

import React, { useState, useEffect } from "react";
import styles from "./App.module.scss";
import ChatLauncher from "./components/ChatLauncher/ChatLauncher";

export default function App() {
  /*
    VIEWPORT ÄR NU HÅRDKODAT TILL DESKTOP!
    DEN VAR TIDIGARE SATT SOM NULL, I.OM FÖRBEREDELSE FÖR IFRAME, 
    DÅ VI SKA HÄMTA FRÅN PARENT!
    //SK
  */

  const [viewport, setViewport] = useState(null);
  const [host, setHost] = useState(null);

  // DYNAMIC METHOD: Receive 'host' and 'vw' (viewport width) via postMessage from parent
  useEffect(() => {
    const handleMessage = (event) => {
      if (!event.data) return;

      const { host, vw } = event.data;
      if (host) setHost(host);
      if (vw)
        setViewport(vw >= 1000 ? "desktop" : vw >= 680 ? "tablet" : "mobile");
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  // FALLBACK METHOD: Extract 'host' and 'vw' directly from URL query parameters (useful for testing)
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    let h = params.get("host");
    if (h) {
      h = decodeURIComponent(h);
      if (!/^https?:\/\//.test(h)) h = `https://${h}`;
      setHost(h);
    }

    const vw = params.get("vw");
    if (vw) {
      const w = parseInt(vw, 10);
      setViewport(w >= 1000 ? "desktop" : w >= 680 ? "tablet" : "mobile");
    }
  }, []);

  /*
  LOG TO THE AGAINST IFRAME IN THE FUTURE.
   */
  useEffect(() => {
    console.log("Viewport state:", viewport);
  }, [viewport]);

  return (
    <div className={styles.appContainer}>
      <ChatLauncher viewport={viewport} host={host} />
    </div>
  );
}
